// do this whenever you load a page
// so also when loading a new history.js page
// often occurs in <main> or changing navigations

// imports --------------------------------------------------------------------
import { fixLocalTesting } from '../js_vendor/FixLocalTesting.js';
import { setActiveMenuItems } from '../js_vendor/SetActiveMenuItems.js';

// import * as Cookies from './0-cookies-v3.4.js';
import * as Vars from './0-vars.js';
import * as Once from './2-once.js';
import * as Resize from './4-resize.js';
// import * as Example from './example.js';
// import * as VideoEmbed from './6-video-embed-v2.5.js';
import * as MediaItems from './6-media-items-v1.7.js';

// Import Swiper JS
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation.min.css';
Swiper.use([Navigation, Autoplay]);

// user variables ---------------------------------------------------------
export const gradientEls = document.body.querySelectorAll('.gradient');
export const chartsEls = document.body.querySelectorAll('.charts');
const navItemClasses = ['nav-list__link']; // add &[aria-current="page"] to styles for active state

const handleCountryCode = async (goToLang) => {
  // console.log('handleCountryCode', {goToLang});
  
  const endpoint = 'wp-json/bbcapital/v1/country-code';
  const url = `${$baseUrl}${endpoint}`;

  try {
    const response = await fetch(url, {
      headers: {
        Accept: 'application/json',
      },
    });

    const data = await response.json();
    const countryCode = (data?.country_code || '').toLowerCase();
    const englishHomeUrl = $languages?.en?.url || $baseUrl + 'en/';

    // console.log('handleCountryCode', {countryCode, englishHomeUrl, goToLang});

    if (!countryCode) return;

    if (countryCode !== 'nl' && countryCode !== 'be' && englishHomeUrl && goToLang === 'en') {
      window.location.replace(englishHomeUrl);
    } else if ((countryCode === 'nl' || countryCode === 'be') && goToLang === 'nl') {
      window.location.replace($baseUrl);
    } else {
      // console.warn('Country code not found in response:', data);
    }

    return countryCode;
  } catch (error) {
    console.error('Failed to load country code', error);
    return '';
  }
};

// new page function ----------------------------------------------------------
export const setPage = ({prepareFaderForViewTransition = window.blPageTransition} = {}) => {
  // sets all the pages
  // console.log('setPage');

  // setters -----------------------------------------------
  fixLocalTesting(); // before historySetPage, because it might change URLs
  setActiveMenuItems(navItemClasses, {postTypeSlugs: $arPostTypes, baseUrl: $url}); // after fixLocalTesting, because it might change URLs
  // if ('setExample' in Example) Example.setExample();
  if (Once.splitter && typeof Once.splitter.setSplitters === 'function') Once.splitter.setSplitters();
  if (Once.vtOutOfView && typeof Once.vtOutOfView.refreshElements === 'function') Once.vtOutOfView.refreshElements(); // saves elements array to var
  if (Once.horScroller && typeof Once.horScroller.refreshElements === 'function') Once.horScroller.refreshElements(true);
  if ('setMediaItems' in MediaItems) MediaItems.setMediaItems();

  // homepage language check and redirect if needed -----------------------------------------------
  const browserLanguage = navigator.language || navigator.languages?.[0] || '';

  // console.log({browserLanguage, href: window.location.href, baseUrl: $baseUrl, redirected: sessionStorage.getItem('bbLanguageSet')});

  if (window.location.href === $baseUrl) {
    const browserIsEnglishLike = /^en(?:$|-)/i.test(browserLanguage);

    if (browserIsEnglishLike && sessionStorage.getItem('bbLanguageSet') !== '1') handleCountryCode('en');
  } else if (window.location.href === $baseUrl + 'en/') {
    const browserIsDutchLike = /^nl(?:$|-)/i.test(browserLanguage);
    // const browserIsDutchLike = true;

    if (browserIsDutchLike && sessionStorage.getItem('bbLanguageSet') !== '1') handleCountryCode('nl');
  }

  // when the user has been redirected, we don't want to redirect them again on subsequent visits
  // also, you don't want to redirect when they go from a homepage to the homepage in another language
  sessionStorage.setItem('bbLanguageSet', '1');

  // initialize Swiper ----------------------------------------------
  const swiperEls = document.querySelectorAll('.slider__swiper');
  swiperEls.forEach(swiperEl => {
    const isCenter = swiperEl.classList.contains('slider__swiper--center');

    const prevBtnEl = swiperEl.parentElement.querySelector('.swiper-button-prev');
    const nextBtnEl = swiperEl.parentElement.querySelector('.swiper-button-next');

    const mySwiper = new Swiper(swiperEl, {
    // Swiper options here
    // modules: [Navigation, Pagination],
      direction: 'horizontal',
      speed: Vars.blTouch ? 400 : 800, // fater on touch devices
      loop: isCenter,
      centeredSlides: isCenter,
      autoplay: {
        enabled: isCenter,
        delay: 2000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: nextBtnEl,
        prevEl: prevBtnEl,
      },
      variableWidth: true,
      slidesPerView: 'auto',
      touchStartPreventDefault: Vars.blTouch ? true : false, // so aim moves when swiping
    });
  });

  // browser color
  const background = getComputedStyle(document.body).getPropertyValue('background-color');
  document.querySelector('meta[name="theme-color"]').setAttribute('content', background);
  
  // most of the time it's better to do an element check instead of a pageType check
  // switch ($pageType) {
  // }

  if (!Once.useHistoryNavigation) setPageAfterSetScroll(); 
};

export const setPageAfterSetScroll = ({prepareFaderForViewTransition = window.blPageTransition, delay = true} = {}) => {
  // console.log('setPageAfterSetScroll', {prepareFaderForViewTransition});

  if ('fader' in Once && typeof Once.fader.init === 'function') Once.fader.init(); // has a safeguard against multiple inits

  // has vt and new page
  if (prepareFaderForViewTransition && 'fader' in Once) Once.fader.doSkipOnLoadInView(false); // false to not call setFaders, done below

  if (prepareFaderForViewTransition || !delay) {
    Once.observerUnblocker(); // calls setResize() and setFaders();
  } else {
    // no vt and transitionDelay exists
    setTimeout(Once.observerUnblocker, Once.transitionDelay - 200); // looks nice to start fader before the end of the main fade-in 
  }
};
